import { useLocalStorage } from '@festina-life/ui/hooks'

import type { SearchableItemGroup } from './types'

export type CommandPaletteFilters = {
  shouldHideFavourites: boolean
  shouldHideWarnings: boolean
  shouldHideUnauthorized: boolean
}

const defaultShouldHide: CommandPaletteFilters = {
  shouldHideFavourites: false,
  shouldHideWarnings: false,
  shouldHideUnauthorized: true,
}

export type CommandPaletteLocalStrorageType = {
  favouriteKeys: string[]
} & CommandPaletteFilters

const DEFAULT_FAVOURITES: Record<
  SearchableItemGroup,
  CommandPaletteLocalStrorageType
> = {
  command: {
    favouriteKeys: [],
    ...defaultShouldHide,
  },
  navigation: {
    favouriteKeys: [],
    ...defaultShouldHide,
  },
  tenant: {
    favouriteKeys: [],
    ...defaultShouldHide,
  },
  recent: {
    favouriteKeys: [],
    ...defaultShouldHide,
  },
}

export const useCommandPaletteLocalStorage = () => {
  const [favourites, setFavourites] = useLocalStorage<
    Record<
      SearchableItemGroup,
      {
        favouriteKeys: string[]
      } & CommandPaletteFilters
    >
  >('command-palette-preferences')

  return [favourites ?? DEFAULT_FAVOURITES, setFavourites] as const
}
